import { useState } from 'react';
import Modal from '../shared/Modal';
import { sendKidsAvailabilityRequests, sendKidsAvailabilityTest } from '../../utils/api';

// Kids "tell us your plans" blast: emails every rostered Kids person their
// personal most-helpful-3 link, and hands the lead a public form link to send
// to people who are NOT in the system yet (that form matches by email or adds
// them as Not Registered).

export default function KidsAvailabilityRequestModal({ open, onClose, showToast, senderEmail, memberCount }) {
  const [sending, setSending] = useState(false);
  const [testing, setTesting] = useState(false);
  const [result, setResult] = useState(null);

  const publicUrl = `${window.location.origin}/kids-availability`;

  async function handleSend() {
    setSending(true);
    setResult(null);
    try {
      const r = await sendKidsAvailabilityRequests(senderEmail);
      setResult(r);
      showToast(`Availability request sent to ${r.sent} people.`);
    } catch (e) {
      showToast('Send failed — check the Apps Script logs.');
    } finally {
      setSending(false);
    }
  }

  async function handleTest() {
    setTesting(true);
    try {
      await sendKidsAvailabilityTest(senderEmail);
      showToast(`Test sent to ${senderEmail} — check your inbox.`);
    } catch (e) {
      showToast('Test send failed — check the Apps Script logs.');
    } finally {
      setTesting(false);
    }
  }

  function copyPublicLink() {
    navigator.clipboard.writeText(publicUrl);
    showToast('Public form link copied.');
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Request Availability"
      footer={
        <>
          <button className="btn" onClick={onClose}>Close</button>
          <button className="btn" onClick={handleTest} disabled={testing || sending} title={`Sends the email to ${senderEmail} only`}>
            {testing ? 'Sending test…' : 'Send Test to Me'}
          </button>
          <button className="btn btn-dark" onClick={handleSend} disabled={sending || testing}>
            {sending ? 'Sending…' : `Email Roster (${memberCount || 0})`}
          </button>
        </>
      }
    >
      <div style={{ fontFamily: 'var(--font-b)', fontSize: 14, fontWeight: 300, color: 'var(--mid)', lineHeight: 1.7, marginBottom: 16 }}>
        Everyone on the Kids roster gets an email with their personal availability link — they pick
        <strong style={{ fontFamily: 'var(--font-h)', fontWeight: 700 }}> how many sessions</strong> they can serve, then check
        <strong style={{ fontFamily: 'var(--font-h)', fontWeight: 700 }}> which ones</strong> they're free for
        (the "most helpful 3" flow). You'll see their answers on the roster and in the Fill picker.
      </div>

      {result && (
        <div style={{ background: '#f0f7f0', border: '1px solid #1a5c3a', borderRadius: 'var(--radius)', padding: '10px 14px', marginBottom: 16, fontFamily: 'var(--font-b)', fontSize: 13 }}>
          Sent to {result.sent} people{result.skipped ? ` · ${result.skipped} skipped (no email)` : ''}{result.errors?.length ? ` · ${result.errors.length} failed` : ''}.
        </div>
      )}

      <div style={{ borderTop: '1px solid var(--border)', paddingTop: 16 }}>
        <div style={{ fontFamily: 'var(--font-h)', fontSize: 11, fontWeight: 700, letterSpacing: '0.16em', textTransform: 'uppercase', color: 'var(--muted)', marginBottom: 8 }}>
          People not in the system yet
        </div>
        <div style={{ fontFamily: 'var(--font-b)', fontSize: 13, fontWeight: 300, color: 'var(--mid)', lineHeight: 1.6, marginBottom: 10 }}>
          Send this public link to anyone who hasn't registered (or isn't on the roster). When they fill
          it out, we match them by email — or add them here as <strong style={{ fontFamily: 'var(--font-h)', fontWeight: 700 }}>Not Registered</strong> so
          you can chase their registration.
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <input className="form-input" readOnly value={publicUrl} style={{ flex: 1, fontSize: 12 }} onFocus={e => e.target.select()} />
          <button className="btn btn-sm" onClick={copyPublicLink}>Copy</button>
        </div>
      </div>
    </Modal>
  );
}
